module.exports = __webpack_public_path__ + "static/img/far5.99052adf.png";